import React from "react";

import { Trans, withTranslation } from "react-i18next";
import i18n from '../../i18n';

import {
  H4,
  H5,
  Callout,
  Button,
  Dialog,
  Classes,
  Intent,
  Spinner,
  Tag,
  Menu,
  MenuItem,
  InputGroup,
  FormGroup,
  Card,
  HTMLSelect
} from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";


import { getLoggedUserLevel } from "../auth/Signin";
import { authenticatedGetFetch, authenticatedPostFetch, authenticatedDeleteFetch, authenticatedPutFetch } from "../../utils/AuthenticatedFetch";

class AlertEditor extends React.Component {
  constructor(props) {
    super();
    this.state = {
      alert: JSON.parse(JSON.stringify(props.alert)),
      title: props.alert.lbl,
      runningEdit: false,
      addEvent: false,
      addUser: false
    };
    this.EventList = this.EventList.bind(this);
    this.UserList = this.UserList.bind(this);
    this.AddEvent = this.AddEvent.bind(this);
    this.AddUser = this.AddUser.bind(this);
  }

  EventList(props) {
    const ret = [];
    for (const e of this.state.alert.events) {
      ret.push(<Tag
        onRemove={() => {
          const index = this.state.alert.events.indexOf(e);
          if (index > -1)
            props.events.splice(index, 1);
          this.setState({ alert: this.state.alert })
        }}
        large={true}
      >{i18n.t("event" + e)}</Tag>)
    }
    return <div className="flexbox-left">{ret}</div>;
  }

  AddEvent(props) {
    return (
      <div>
        {(this.state.addEvent) ?
          <Select
            items={Array.from(Array(560).keys())}
            itemRenderer={(item, { selecttt, modifiers }) => {
              return <MenuItem
                label={i18n.t("event" + item)}
                text={item}
                onClick={() => {
                  console.log("add event " + item);
                  const tmp = JSON.parse(JSON.stringify(this.state.alert));
                  tmp.events.push(item);
                  this.setState({ alert: tmp, addEvent: false });
                }}
                itemListRenderer={({ items, itemsParentRef, query, renderItem }) => {
                  const renderedItems = items.map(renderItem).filter(item => (item != null && item.props.text != null && item.props.text.toUpperCase().includes(query.toUpperCase())));
                  return (
                    <Menu ulRef={itemsParentRef}>
                      <MenuItem
                        disabled={true}
                      />
                      {renderedItems}
                    </Menu>
                  );
                }}
              />
            }}
          >
            <Button text={this.state.event !== undefined ? i18n.t("event" + this.state.event) : i18n.t("select an event to add")} rightIcon="double-caret-vertical" />
          </Select>
          :
          <Button
            onClick={() => {
              this.setState({ addEvent: true });
              console.log(this.state)
            }}
            icon="add"
          />}
      </div>);
  }

  AddUser(props) {
    return (
      <div>
        {(this.state.addUser) ?
          <Select
            items={Array.from(Array(this.props.users.length).keys())}
            itemRenderer={(item, { selecttt, modifiers }) => {
              return <MenuItem
                text={this.props.users[item].login}
                onClick={() => {
                  console.log("add user " + item);
                  const tmp = JSON.parse(JSON.stringify(this.state.alert));
                  tmp.users.push(this.props.users[item]);
                  this.setState({ alert: tmp, addUser: false });
                }}
                itemListRenderer={({ items, itemsParentRef, query, renderItem }) => {
                  const renderedItems = items.map(renderItem).filter(item => (item != null && item.props.text != null && item.props.text.toUpperCase().includes(query.toUpperCase())));
                  return (
                    <Menu ulRef={itemsParentRef}>
                      <MenuItem
                        disabled={true}
                      />
                      {renderedItems}
                    </Menu>
                  );
                }}
              />
            }}
          >
            <Button text={this.state.user !== undefined ? i18n.t("user" + this.state.user) : i18n.t("select a user to add")} rightIcon="double-caret-vertical" />
          </Select>
          :
          <Button
            onClick={() => {
              this.setState({ addUser: true });
              console.log(this.state)
            }}
            icon="add"
          />}
      </div>);
  }

  UserList(props) {
    const ret = [];
    for (const u of this.state.alert.users) {
      ret.push(
        <Tag
          key={u.id}
          onRemove={() => {
            const index = this.state.alert.users.indexOf(u);
            if (index > -1)
              props.users.splice(index, 1);
            this.setState({ users: this.state.users })
          }}
          large={true}
        >
          {u.login}
        </Tag>)
    }
    return <div className="flexbox-left">{ret}</div>;
  }

  render() {
    return (
      <div>
        <Dialog
          isOpen={this.state.runningEdit}
          style={{ transition: 'none' }}
        >
          <div className={Classes.DIALOG_BODY}>
            <H4><Trans>edit alert</Trans> <i>{this.state.alert.lbl}</i></H4>
            <Callout hidden={!this.state.errorEdit} intent="danger"><Trans>an eror occured, please try again later.</Trans></Callout>
            <FormGroup
              label={<Trans>alert's title</Trans>}
              labelFor="title"
            >
              <InputGroup
                type="text"
                id="title"
                value={this.state.title}
                onChange={(ti) => { this.setState({ title: ti.target.value }); }}
              />
            </FormGroup>
            <HTMLSelect
              options={[{ label: i18n.t("normal"), value: "primary" }, { label: i18n.t("minor"), value: "warning" }, { label: i18n.t("major"), value: "danger" },]}
              onChange={(s) => this.setState({ intent: s.target.value })}
              disabled={this.state.filter === 'all'}
              value={this.state.alert.intent}
            />
            <div>
              <H5><Trans>monitored events</Trans></H5>
              <div className="flexbox-left">
                <this.EventList events={this.state.alert.events} />
                <this.AddEvent events={this.state.eventList} />
              </div>
              <H5><Trans>notified users</Trans></H5>
              <div className="flexbox-left">
                <this.UserList users={this.state.alert.users} />
                <this.AddUser events={this.state.eventList} />
              </div>
            </div>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div hidden={!this.state.loading}><Spinner /></div>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button
                icon='undo'
                intent={Intent.DANGER}
                disabled={this.state.loading}
                onClick={() => this.setState({
                  runningEdit: false,
                  addEvent: false,
                  addUser: false
                })}
              >
                <Trans>cancel</Trans>
              </Button>
              <Button icon='send-to'
                loading={this.state.loading}
                onClick={() => {
                  authenticatedPutFetch('/alert',
                    { id: this.state.alert.id, lbl: this.state.title, users: this.state.alert.users.map(usr => usr.id), events: this.state.alert.events, intent: this.state.intent },
                    () => {
                      this.setState({ runningEdit: false, delete: {} });
                      this.props.onModify();
                    })
                }}
              >
                <Trans>send</Trans>
              </Button>
            </div>
          </div>
        </Dialog>
        <Button icon="edit" onClick={() => this.setState({ runningEdit: true, alert: JSON.parse(JSON.stringify(this.props.alert)), })} />
      </div>
    );
  }
}

class AlertCreator extends React.Component {
  constructor(props) {
    super();
    this.state = {
      title: "Nom de l'alerte",
      runningCreate: false,
      addEvent: false,
      addUser: false,
      s_events: [],
      s_users: [],
      intent: "primary"
    };
    this.EventList = this.EventList.bind(this);
    this.UserList = this.UserList.bind(this);
    this.AddEvent = this.AddEvent.bind(this);
    this.AddUser = this.AddUser.bind(this);
  }

  EventList(props) {
    const ret = [];
    for (const e of this.state.s_events) {
      ret.push(<Tag
        onRemove={() => {
          const tmp = JSON.parse(JSON.stringify(this.state.s_events))
          const index = tmp.indexOf(e);
          if (index > -1)
            tmp.splice(index, 1);
          this.setState({ s_events: tmp })
        }}
        large={true}
      >{i18n.t("event" + e)}</Tag>)
    }
    return <div className="flexbox-left">{ret}</div>;
  }

  AddEvent(props) {
    return (
      <div>
        {(this.state.addEvent) ?
          <Select
            items={Array.from(Array(560).keys())}
            itemRenderer={(item, { selecttt, modifiers }) => {
              return <MenuItem
                label={i18n.t("event" + item)}
                text={item}
                onClick={() => {
                  console.log("add event " + item);
                  const tmp = JSON.parse(JSON.stringify(this.state.s_events));
                  tmp.push(item);
                  this.setState({ s_events: tmp, addEvent: false });
                }}
                itemListRenderer={({ items, itemsParentRef, query, renderItem }) => {
                  const renderedItems = items.map(renderItem).filter(item => (item != null && item.props.text != null && item.props.text.toUpperCase().includes(query.toUpperCase())));
                  return (
                    <Menu ulRef={itemsParentRef}>
                      <MenuItem
                        disabled={true}
                      />
                      {renderedItems}
                    </Menu>
                  );
                }}
              />
            }}
          >
            <Button text={this.state.event !== undefined ? i18n.t("event" + this.state.event) : i18n.t("select a specific event")} rightIcon="double-caret-vertical" />
          </Select>
          :
          <Button
            onClick={() => {
              this.setState({ addEvent: true });
              console.log(this.state)
            }}
            icon="add"
          />}
      </div>);
  }

  AddUser(props) {
    return (
      <div>
        {(this.state.addUser) ?
          <Select
            items={Array.from(Array(this.props.users.length).keys())}
            itemRenderer={(item, { selecttt, modifiers }) => {
              return <MenuItem
                text={this.props.users[item].login}
                onClick={() => {
                  console.log("add user " + item);
                  const tmp = JSON.parse(JSON.stringify(this.state.s_users));
                  tmp.push(this.props.users[item]);
                  this.setState({ s_users: tmp, addUser: false });
                }}
                itemListRenderer={({ items, itemsParentRef, query, renderItem }) => {
                  const renderedItems = items.map(renderItem).filter(item => (item != null && item.props.text != null && item.props.text.toUpperCase().includes(query.toUpperCase())));
                  return (
                    <Menu ulRef={itemsParentRef}>
                      <MenuItem
                        disabled={true}
                      />
                      {renderedItems}
                    </Menu>
                  );
                }}
              />
            }}
          >
            <Button text={this.state.user !== undefined ? i18n.t("user" + this.state.user) : i18n.t("select a user to add")} rightIcon="double-caret-vertical" />
          </Select>
          :
          <Button
            onClick={() => {
              this.setState({ addUser: true });
              console.log(this.state)
            }}
            icon="add"
          />}
      </div>);
  }

  UserList(props) {
    const ret = [];
    for (const u of this.state.s_users) {
      ret.push(
        <Tag
          key={u.id}
          onRemove={() => {
            const tmp = this.state.s_users;
            const index = tmp.indexOf(u);
            if (index > -1)
              tmp.splice(index, 1);
            this.setState({ s_users: tmp })
          }}
          large={true}
        >
          {u.login}
        </Tag>)
    }
    return <div className="flexbox-left">{ret}</div>;
  }

  render() {
    return (
      <div>
        <Dialog
          isOpen={this.state.runningCreate}
          style={{ transition: 'none' }}
        >
          <div className={Classes.DIALOG_BODY}>
            <H4><Trans>edit alert</Trans> <i>{this.state.title}</i></H4>
            <Callout hidden={!this.state.errorEdit} intent="danger"><Trans>an eror occured, please try again later.</Trans></Callout>
            <FormGroup
              label={<Trans>alert's title</Trans>}
              labelFor="title"
            >
              <InputGroup
                type="text"
                id="title"
                value={this.state.title}
                onChange={(ti) => { this.setState({ title: ti.target.value }); }}
              />
            </FormGroup>
            <HTMLSelect
              options={[{ label: i18n.t("normal"), value: "primary" }, { label: i18n.t("minor"), value: "warning" }, { label: i18n.t("major"), value: "danger" },]}
              onChange={(s) => this.setState({ intent: s.target.value })}
              disabled={this.state.filter === 'all'}
            />
            <div>
              <H5><Trans>monitored events</Trans></H5>
              <div className="flexbox-left">
                <this.EventList events={this.state.s_events} />
                <this.AddEvent events={this.state.eventList} />
              </div>
              <H5><Trans>notified users</Trans></H5>
              <div className="flexbox-left">
                <this.UserList users={this.state.s_users} />
                <this.AddUser events={this.state.eventList} />
              </div>
            </div>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div hidden={!this.state.loading}><Spinner /></div>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button
                icon='undo'
                intent={Intent.DANGER}
                disabled={this.state.loading}
                onClick={() => this.setState({
                  runningCreate: false,
                  addEvent: false,
                  addUser: false
                })}
              >
                <Trans>cancel</Trans>
              </Button>
              <Button icon='send-to'
                loading={this.state.loading}
                onClick={() => {
                  authenticatedPostFetch('/alert',
                    { lbl: this.state.title, users: this.state.s_users.map(usr => usr.id), events: this.state.s_events, intent: this.state.intent },
                    () => {
                      this.setState({ runningCreate: false, delete: {} });
                      this.props.onModify();
                    })
                }}
              >
                <Trans>send</Trans>
              </Button>
            </div>
          </div>
        </Dialog>
        <Button icon="new-object" onClick={() => this.setState({ runningCreate: true })} >
          <Trans>create a new alert</Trans>
        </Button>
      </div>
    );
  }
}

class AlertList extends React.Component {
  constructor() {
    super();
    this.state = {
      alerts: [],
      delete: {},
      edit: {},
      runningDelete: false,
      runningEdit: false,
      errorDelete: false,
      errorEdit: false,
      loading: false
    };
  }

  render() {
    const alerts = [];
    for (const a of this.props.list) {
      alerts.push(
        <Card key={a.lbl}>
          <div className="flexbox-left">

            {/* DELETE */}
            <Dialog
              isOpen={this.state.runningDelete}
              style={{ transition: 'none' }}
            >
              <div className={Classes.DIALOG_BODY}>
                <Trans>delete alert</Trans> <b>{a.lbl}</b>
                <Callout hidden={!this.state.errorDelete} intent="danger"><Trans>an eror occured, please try again later.</Trans></Callout>
              </div>
              <div className={Classes.DIALOG_FOOTER}>
                <Trans>this operation is irreversible</Trans>
                <div hidden={!this.state.loading}><Spinner /></div>
                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                  <Button
                    icon='undo'
                    intent={Intent.DANGER}
                    disabled={this.state.loading}
                    onClick={() => this.setState({ runningDelete: false, delete: {} })}
                  >
                    <Trans>cancel</Trans>
                  </Button>
                  <Button icon='trash'
                    loading={this.state.loading}
                    onClick={() => {
                      console.log("delete alert" + JSON.stringify(this.state.delete));
                      authenticatedDeleteFetch('/alert', { id: this.state.delete.id }, () => {
                        this.setState({ runningDelete: false, delete: {} });
                        this.props.onModify();
                      })
                    }}
                  >
                    <Trans>delete</Trans>
                  </Button>
                </div>
              </div>
            </Dialog>
            <Button icon="trash" onClick={() => this.setState({ runningDelete: true, delete: a })} />

            <AlertEditor alert={a} eventList={this.props.eventList} users={this.props.users} onModify={this.props.onModify} />

            <H4 style={{ marginLeft: 20 }}>{a.lbl}</H4>
            <Callout intent="primary"><Trans>contains</Trans> {a.events.length} <Trans>events tracked and diffused to</Trans> {a.users.length} <Trans>user(s)</Trans></Callout>
          </div>
        </Card>);
    }
    return alerts;
  }
}

class AlertManager extends React.Component {

  constructor() {
    super();
    this.state = {
      loaded: false
    };
    this.onModify = this.onModify.bind(this);
  }

  componentDidMount() {
    if (getLoggedUserLevel() > 0) {
      authenticatedGetFetch('/alerts',
        (response) => {
          this.setState({ enabled: response });
          authenticatedGetFetch('/logins',
            (response) => {
              this.setState({ UserList: response, loaded: true });
            });
        });
    }
  }

  onModify() {
    try {
      this.setState({ loaded: false });
      authenticatedGetFetch('/alerts',
        (response) => {
          this.setState({ enabled: response });
          authenticatedGetFetch('/logins',
            (response) => {
              this.setState({ UserList: response, loaded: true });
            });
        });
    } catch (e) { console.log(e); }
  }

  render() {
    return (
      <Callout title={<Trans>alert management</Trans>} icon="notifications">
        {this.state.loaded ?
          <div>
            <Callout intent="primary">
              <Trans>alerts appears as notification for all given users.</Trans>
            </Callout>
            <Callout intent="warning">
              <Trans>When a user set the alert as solved, it will also solve it from the other users point of view.</Trans>
            </Callout>
            <AlertList list={this.state.enabled} eventList={this.state.eventList} users={this.state.UserList} onModify={this.onModify} />
            <AlertCreator eventList={this.state.eventList} users={this.state.UserList} onModify={this.onModify} />
          </div> :
          <Spinner />}
      </Callout>
    )
  }
}

export default withTranslation()(AlertManager);